import { toJS } from 'mobx'
import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { snakeCase } from 'lodash';

import { SheetFooter, SheetBody, Row, Col, Button, Label, FormGroup, Input as TWInput } from 'twyne-new.ui'
import Input from 'components/form/Input';
import AutocompleteInput from 'components/AutocompleteInput';
import InfoTip from 'components/InfoTip';
import Select from 'components/form/Select';
import SelectOptions from './SelectOptions';
import Switch from 'components/form/Switch';

export const typeOptions = [
  { value: 'input', label: 'Text' },
  { value: 'integer', label: 'Integer' },
  { value: 'select', label: 'Option' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'date', label: 'Date' }
]

const dateAutocompletitions = [
  "mm/dd/yyyy",
  "mm-dd-yyyy",
  "dd-mm-yyyy",
  "dd/mm/yyyy",
  "yyyy-mm-dd",
  "yyyy/mm/dd"
]

class FieldForm extends React.Component {
  state = {
    options: [],
    repeatedValuesSelect: {},
    type: '',
    key: ''
  };

  componentWillMount() {
    let data = this.props.data;
    if (data) {
      this.setState(toJS(data));
    }
  }

  handleChangeName = (event) => {
    if (!this.state.id) {
      this.setState({ key: snakeCase(event.target.value) });
    }
  }

  handleChangeType = (option) => {
    this.setState(() => {
      const state = { type: option ? option.value : '' }

      if (state.type === 'date')
        state.date_format = 'mm/dd/yyyy'

      return state
    });
  }

  handleValidSubmit = (model) => {
    const state = this.state

    if (state.type !== 'select')
      state.options = null

    if (state.type !== 'date')
      state.date_format = null

    model.key = state.key;

    if (!Object.entries(state.repeatedValuesSelect).length) {
      this.props.handleSubmit(Object.assign(state, model));
    }
  }

  handleChange = (prop) => {
    this.setState(prop)
  }

  renderTypeOptions() {
    if (this.state.type === 'date') {
      return <Col size="12">
        <FormGroup>
          <FormGroup>
            <span className='flex gap-1'>
              <Label>Format</Label>
              <InfoTip id='twyne_preping-info' side='right'>
                Set date format using "dd" for day, "mm" for month and "yyyy" for year.
              </InfoTip>
            </span>
            <AutocompleteInput
              className="form-control"
              trigger=""
              spacer=""
              options={dateAutocompletitions}
              value={this.state.date_format}
              onChange={(value) => this.setState({ date_format: value })}
              required
            />
          </FormGroup>
        </FormGroup>
      </Col>
    }

    if (this.state.type === 'select') {
      const options = this.state.options || []
      return <Col size="12">
        <FormGroup>
          <SelectOptions
            options={options}
            onChange={this.handleChange}
            repeatedValuesSelect={this.state.repeatedValuesSelect}
          />
        </FormGroup>
      </Col>
    }
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Row>
            <Col size="12">
              <FormGroup>
                <Label>Name</Label>
                <Input name="name" value={this.state.name || ''} onChange={this.handleChangeName} required />
              </FormGroup>
            </Col>
            <Col size="12">
              <FormGroup>
                <Label>Key</Label>
                <TWInput name="key" value={this.state.key} disabled />
              </FormGroup>
            </Col>
            <Col size="12">
              <FormGroup>
                <Label>Type</Label>
                <Select name="type" value={this.state.type} options={typeOptions}
                  handleOnChange={this.handleChangeType} required />
              </FormGroup>
            </Col>
            {this.renderTypeOptions()}
            <Col size="6">
              <FormGroup>
                <Label>Private</Label>
                <Switch name="private" value={this.state.private || false} />
              </FormGroup>
            </Col>
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.props.onCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>

      </Formsy>
    );
  }
}

FieldForm.propTypes = {
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.any
};

export default FieldForm;
